import { SxProps, Theme } from '@mui/material'

export const PLAN_SECTION_MAX_WIDTH_IN_PX = {
  DESKTOP: 272,
  BIG_DESKTOP: 297.6,
}

export const planItemSx = ({
  mobileView,
  isDesktop,
}: {
  mobileView: boolean
  isDesktop: boolean
}): SxProps<Theme> => {
  const BORDER = '0.1rem solid #DFDFDF'
  const view = {
    MOBILE: {
      border: 'none',
      maxWidth: '100%',
      borderBottomLeftRadius: '2rem',
      borderBottomRightRadius: '2rem',
    },
    DESKTOP: {
      border: BORDER,
      maxWidth: `${PLAN_SECTION_MAX_WIDTH_IN_PX.DESKTOP}px`,
    },
    BIG_DESKTOP: {
      border: BORDER,
      maxWidth: `${PLAN_SECTION_MAX_WIDTH_IN_PX.BIG_DESKTOP}px`,
    },
  }

  const propertiesToUse = (() => {
    let viewToUse = view.BIG_DESKTOP

    if (mobileView) {
      viewToUse = view.MOBILE
    } else if (isDesktop) {
      viewToUse = view.DESKTOP
    }

    return viewToUse
  })()

  return {
    ...propertiesToUse,
    padding: '1.2rem',
    background: (theme) => theme.palette.common.white,
    '&:not(:first-of-type)': {
      borderLeft: 'none',
    },
  }
}

export const planStackSx: SxProps<Theme> = {
  rowGap: '2.8rem',
  margin: '2rem 0',
}

export const featureSx: SxProps<Theme> = {
  alignItems: 'center',
  gap: '1.4rem',
  paddingX: '0.6rem',
}

const cellIconDefaultSx: SxProps<Theme> = {
  width: '3.6rem',
  height: '3.6rem',
  verticalAlign: 'middle',
}

export const cellCloseIconSx: SxProps<Theme> = {
  ...cellIconDefaultSx,

  color: (theme) => theme.palette.text.primary,
  opacity: 0.3,
}

export const cellCheckCircleIconSx: SxProps<Theme> = {
  ...cellIconDefaultSx,

  color: (theme) => theme.palette.secondary.main,
}

export const cellCheckIconSx: SxProps<Theme> = {
  ...cellIconDefaultSx,

  color: (theme) => theme.palette.primary.light,
}
